import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { Loader } from "rsuite";
import { axInst } from "../../../Components/Login/Service";

import DonutChart from "../../../Components/Charts/DonutChart";
import ProgressCard from "../../../Components/Charts/ProgressBar";

/* API CALL */
const fetchZoneCards = async (body) => {
  try {
    const res = await axInst.post("/collbax-service/zone_wise_cards", body);
    return res.data;
  } catch (error) {
    console.error(error);
    return {};
  }
};

export default function ZoneCard() {
  const { data, submitted } = useSelector((e) => e.filtersServiceCollabax);

  const {
    data: ZoneCardsData,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["zoneCards", submitted],
    queryFn: () => fetchZoneCards(data),
    cacheTime: 0,
    staleTime: 0,
  });

  if (isFetching)
    return (
      <div className="flex justify-center items-center">
        <Loader />
      </div>
    );

  if (isError) return <div>Error loading data</div>;

  /* Extract API Data */
  const workshop = ZoneCardsData?.workshop?.[0] || {};
  const bays = ZoneCardsData?.bays?.[0] || {};
  const sar = ZoneCardsData?.sar_card?.[0] || {};
  const cpsc = ZoneCardsData?.cpsc_card?.[0] || {};

  /* ✅ Donut Data Mapping */
  const sarDonut = [
    { value: sar.above_80 || 0, name: "Above 80%" },
    { value: sar.below_60 || 0, name: "Below 60%" },
    { value: sar.between_60_80 || 0, name: "Between 60% - 80%" },
  ];

  const cpscDonut = [
    { value: cpsc.above_200 || 0, name: "Above 200" },
    { value: cpsc.below_200 || 0, name: "Below 200" },
  ];

  return (
    <div data-pdf-cards>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-2">
        {/* WORKSHOPS CARD */}
        <ProgressCard
          title="WORKSHOPS"
          total={workshop.total_workshop}
          segments={[
            {
              label: "Dealer",
              value: workshop.dealer,
              color: "#2E6FD9",
            },
            {
              label: "TASS",
              value: workshop.taas,
              color: "#38bdf8",
            },
          ]}
        />

        {/* BAYS CARD */}
        <ProgressCard
          title="BAYS"
          total={bays.total_bays}
          segments={[
            {
              label: "SCV Bays",
              value: bays.scv_bays,
              color: "#F59E0B",
            },
          ]}
        />

        {/* SAR DONUT */}
        <DonutChart
          title="SAR (SLCV Dealers) "
          data={sarDonut}
          total_dealer={`${sar.total_dealer || 0}`}
          saliance={`${sar.salience_score || 0}%`}
        />

        {/* CPSC DONUT */}
        <DonutChart
          title="CPSC "
          data={cpscDonut}
          total_dealer={`${cpsc.total_dealer || 0}`}
          saliance={`${cpsc.salience_score || 0}%`}
        />
      </div>
    </div>
  );
}
